import { buildSimpleSortableColumn } from './buildSimpleSortableColumn';
import { columnIsInSortableDetails } from './columnIsInSortableDetails';
import { buildSortFromDetails } from './buildSortFromDetails';
import { columnIsSortable } from './columnIsSortable';
/**
 * This function is responsible for adding the sort configuration to the columns.
 * @param data
 * @param columns
 * @param sortableDetails
 * @param sortableColumns
 * @param theme
 * @param headerBackgroundColor
 */
export const buildSortableColumns = (data, columns, sortableDetails, sortableColumns, theme, headerBackgroundColor) => {
  if (!Array.isArray(data) || data.length === 0) {
    return columns;
  }

  /**
   *   If sortable details are defined then sort columns defined from sortable details
   *   It will use a combination of sortable details and column data to build sort columns
   *   The sorter value can come from the sortable details if it is defined.
   *   If the sorter value is not defined on the sortable details then a sorter is assigned to the column
   */
  if (sortableDetails) {
    return columns.map(column => {
      if (columnIsInSortableDetails(sortableDetails, column)) {
        return buildSortFromDetails(sortableDetails, column, data, theme, headerBackgroundColor);
      }
      return column;
    });
  }

  /**
   * The following handles the case where the sortableColumns property is true and if there are
   * sort properties defined on the column definitions
   */
  return columns.map(column => {
    if (columnIsSortable(column)) {
      return buildSimpleSortableColumn(sortableColumns, column, data, theme, headerBackgroundColor);
    }
    return column;
  });
};